import { Component, Input } from '@angular/core';

@Component({
    selector: 'allocated-doctor',
    templateUrl: './allocated-doctor.html',
    standalone: false
})
export class AllocatedDoctorComponent {
  @Input('doctor') doctor: any;
}
